import React from 'react';
import NavigationBar from '../navigation/NavigationBar';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <NavigationBar userType="public" />
      <main>{children}</main>
    </div>
  );
};

export default PublicLayout;